class CartDrawer {
  constructor() {
    this.drawer = document.getElementById('CartDrawer');
    this.overlay = document.querySelector('.cart-drawer-overlay');
    this.closeBtn = document.querySelector('.cart-drawer-close');
    this.itemsContainer = document.getElementById('CartDrawerItems');
    this.triggers = document.querySelectorAll('a[href="/cart"], .cart-drawer-trigger');
    
    this.debounceTimeout = null;
    this.pendingUpdates = {}; // Track pending quantity updates to debounce them

    this.init();
  }

  init() {
    // Open drawer on click of cart icons/triggers
    // We use delegation for triggers too, in case they are added dynamically
    document.addEventListener('click', (e) => {
      console.log('CartDrawer: Click detected', e.target);
      
      const trigger = e.target.closest('a[href="/cart"], .cart-drawer-trigger');
      if (trigger) {
        if (this.drawer && this.drawer.contains(trigger)) return;
        e.preventDefault();
        this.open();
        return;
      }

      if (e.target.closest('.cart-drawer-close') || e.target.closest('.cart-drawer-overlay')) {
        this.close();
        return;
      }

      const drawer = document.getElementById('CartDrawer');
      if (drawer && drawer.contains(e.target)) {
        const itemEl = e.target.closest('.cart-drawer-item');
        const id = itemEl ? itemEl.dataset.id : null;
        
        if (id) {
          if (e.target.closest('.qty-plus')) {
            console.log('CartDrawer: Plus clicked', id);
            this.handleQuantityChange(id, 'plus', itemEl);
          } else if (e.target.closest('.qty-minus')) {
            console.log('CartDrawer: Minus clicked', id);
            this.handleQuantityChange(id, 'minus', itemEl);
          } else if (e.target.closest('.item-remove')) {
            console.log('CartDrawer: Remove clicked', id);
            this.removeItem(id);
          }
        }
        
        // Extras Toggles
        if (e.target.id === 'DrawerOrderNoteBtn' || e.target.closest('#DrawerOrderNoteBtn')) {
          this.toggleExtra('DrawerNoteSection');
        } else if (e.target.id === 'DrawerDiscountBtn' || e.target.closest('#DrawerDiscountBtn')) {
          this.toggleExtra('DrawerDiscountSection');
        } else if (e.target.id === 'SaveNoteBtn') {
          this.saveNote();
        } else if (e.target.closest('.btn-apply-discount')) {
          this.applyDiscount();
        }

        // Recommendation Add
        if (e.target.classList.contains('reco-add')) {
          this.addItem(e.target.dataset.variantId);
        }
      }
    });

    // Global Add to Cart form submission
    document.addEventListener('submit', (e) => {
      if (e.target.action && e.target.action.includes('/cart/add')) {
        e.preventDefault();
        this.addFormToCart(e.target);
      }
    });
  }

  open() {
    this.refresh();
    this.drawer.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  close() {
    this.drawer.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  refresh() {
    console.log('CartDrawer: Refreshing...');
    fetch(`/?sections=main-cart-drawer&v=${Date.now()}`)
      .then(response => response.json())
      .then(json => {
        const html = json['main-cart-drawer'];
        if (!html) return;

        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        
        // Use a broader update strategy: update everything inside CartDrawer
        const newBody = doc.querySelector('.cart-drawer-body');
        const oldBody = document.querySelector('.cart-drawer-body');
        if (newBody && oldBody) {
          oldBody.innerHTML = newBody.innerHTML;
        }

        // Update title badge
        const newTitle = doc.querySelector('.cart-drawer-title');
        const oldTitle = document.querySelector('.cart-drawer-title');
        if (newTitle && oldTitle) {
          oldTitle.innerHTML = newTitle.innerHTML;
        }

        this.updateCartCounts();
        this.updateCheckoutForms();

        const storedCode = localStorage.getItem('cart_discount_code');
        const discountInput = document.getElementById('CartDiscount');
        if (storedCode && discountInput && !discountInput.value) {
          discountInput.value = storedCode;
        }

        console.log('CartDrawer: Refresh complete.');
      })
      .catch(err => console.error('CartDrawer: Refresh failed', err));
  }

  rebindEvents() {
    // No longer needed due to full delegation
  }

  updateCartCounts() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        // Update standard counts like Header Cart Badge
        document.querySelectorAll('.cart-item-count-badge, .cart-count, .cart-drawer-count').forEach(el => {
          el.textContent = cart.item_count;
          if (el.classList.contains('cart-count')) {
            el.style.display = cart.item_count > 0 ? 'flex' : 'none';
          }
        });

        // Update sticky floating cart text label
        const floatLabel = document.querySelector('.floating-cart-label');
        if (floatLabel) {
          floatLabel.textContent = `${cart.item_count} ${cart.item_count === 1 ? 'Item' : 'Items'}`;
        }

        // Update sticky floating cart price pill
        const floatPrice = document.querySelector('.floating-cart-price-pill');
        if (floatPrice) {
          floatPrice.textContent = 'Rs. ' + (cart.total_price / 100).toFixed(2);
        }
      });
  }

  addFormToCart(form) {
    const formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(item => {
      this.open();
    })
    .catch(error => {
      console.error('Error adding to cart:', error);
    });
  }

  addItem(variantId) {
    const data = {
      'items': [{
        'id': variantId,
        'quantity': 1
      }]
    };
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(item => {
      this.open();
    })
    .catch(err => {
      console.error('Error adding item:', err);
    });
  }

  handleQuantityChange(id, type, itemElement) {
    const input = itemElement.querySelector('input');
    let currentQty = parseInt(input.value);
    let newQty = type === 'plus' ? currentQty + 1 : currentQty - 1;
    
    if (newQty < 1) return;

    // Show loading state immediately
    itemElement.style.opacity = '0.5';
    
    this.updateItem(id, newQty);
  }

  performUpdates() {
    const updates = { ...this.pendingUpdates };
    this.pendingUpdates = {};

    if (Object.keys(updates).length === 0) return;

    // Show a slight loading state on total to indicate background work
    const totalEl = document.querySelector('.total-price');
    if (totalEl) totalEl.style.opacity = '0.5';

    // We use /cart/update.js to update multiple line items at once
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
    .then(response => response.json())
    .then(cart => {
      this.refresh();
    })
    .catch(err => {
      console.error('Error batch updating cart:', err);
      if (totalEl) totalEl.style.opacity = '1';
    });
  }

  removeItem(id) {
    this.updateItem(id, 0);
  }

  updateItem(id, quantity) {
    const data = {
      'id': id,
      'quantity': quantity
    };
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(cart => {
      this.refresh();
    });
  }

  toggleExtra(id) {
    const el = document.getElementById(id);
    if (!el) return;
    
    document.querySelectorAll('.extra-section').forEach(extra => {
      if (extra.id !== id) extra.classList.remove('active');
    });

    el.classList.toggle('active');
  }

  saveNote() {
    const note = document.getElementById('CartNote').value;
    const saveBtn = document.getElementById('SaveNoteBtn');
    
    saveBtn.textContent = 'Saving...';
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: note })
    })
    .then(response => response.json())
    .then(cart => {
      saveBtn.textContent = 'Saved!';
      setTimeout(() => {
        saveBtn.textContent = 'Save Note';
      }, 2000);
    })
    .catch(error => {
      console.error('Error saving note:', error);
      saveBtn.textContent = 'Error';
    });
  }

  applyDiscount() {
    const code = document.getElementById('CartDiscount').value.trim();
    const applyBtn = document.querySelector('.btn-apply-discount');
    if (!code) return;

    applyBtn.textContent = 'Applying...';
    
    // Store in localStorage so it persists through refreshes
    localStorage.setItem('cart_discount_code', code);

    // Update checkout form(s) to include the discount
    this.updateCheckoutForms(code);

    setTimeout(() => {
      applyBtn.textContent = 'Applied';
      
      // Show success message
      let msg = document.getElementById('DiscountSuccessMsg');
      if (!msg) {
        msg = document.createElement('p');
        msg.id = 'DiscountSuccessMsg';
        msg.style.color = '#10b981';
        msg.style.fontSize = '12px';
        msg.style.marginTop = '8px';
        msg.style.fontWeight = '600';
        document.querySelector('.discount-input-row').parentNode.appendChild(msg);
      }
      msg.textContent = `Discount code saved! It will be verified at checkout.`;

      setTimeout(() => {
        applyBtn.textContent = 'Apply';
      }, 2000);
    }, 500);
  }

  updateCheckoutForms(code) {
    if (!code) code = localStorage.getItem('cart_discount_code');
    if (!code) {
      // Clear if empty
      document.querySelectorAll('input[name="discount"]').forEach(i => i.remove());
      return;
    }

    document.querySelectorAll('form').forEach(form => {
      const action = form.getAttribute('action');
      if (action && action.includes('/cart')) {
        let input = form.querySelector('input[name="discount"]');
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = 'discount';
          form.appendChild(input);
        }
        input.value = code;
      }
    });

    // Also inject into view cart links
    document.querySelectorAll('a[href^="/cart"]').forEach(link => {
      try {
        let url = new URL(link.href);
        url.searchParams.set('discount', code);
        link.href = url.toString();
      } catch (e) {
        // Fallback for relative simple links
        if (link.href.includes('?')) {
          if (!link.href.includes('discount=')) link.href += `&discount=${code}`;
        } else {
          link.href += `?discount=${code}`;
        }
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.CartDrawerInstance = new CartDrawer();
});
